export function getSlugs(groupID, className = 'js-fm') {
    let slugs = [];

    $(`.${className}[data-group=${groupID}]`).find('[data-slug]').each(function (index, element) {
        slugs.push($(this).attr('data-slug'));
    });

    slugs = [...new Set(slugs)];

    return slugs;
}

export function getFiles(slugs) {
    var settings = {
        "url": "https://apicatalog.mziq.com/filemanager/company/" + COMPANIES[0].id + "/filter/categories/meta",
        "method": "POST",
        "timeout": 0,
        "headers": {
          "content-type": "application/json"
        },
        "data": JSON.stringify({
          "categoryInternalNames": slugs,
          "language": "pt_BR",
          "published": true
        }),
    };
    
    return $.ajax(settings);
}

function formatDate(date) {
    const options = { year: 'numeric', month: 'long' };
    return new Date(date).toLocaleDateString('pt-BR', options).replace(' de ', ' '); 
}    

export function getFilesOrganized(response, slugs) {
    const arquivosFiltrados = response.filter(item => 
        item.is_published && slugs.includes(item.category_internal_name)
    );
    
    const arquivosOrganizados = arquivosFiltrados.reduce((acc, item) => {
        const formattedDate = formatDate(item.file_published_date || item.file_date);

        if (!acc[item.category_internal_name]) {
            acc[item.category_internal_name] = {
                dates: [],
                arquivos: []
            };
        }
        
        if (!acc[item.category_internal_name].dates.includes(formattedDate)) {
            acc[item.category_internal_name].dates.push(formattedDate);
        }
        
        acc[item.category_internal_name].arquivos.push({
            permalink: item.permalink,
            formattedDate: formattedDate,
            file_published_date: item.file_published_date || item.file_date,
            file_title: item.file_title,
        });

        return acc;
    }, {});

    return arquivosOrganizados;
}

export function generateDOM(files, elements) {
    $.each(elements, function (i, e) { 
        const slug = $(this).attr('data-slug');
        const filesForSlug = files[slug];

        $(this).html('');

        let yearSelectHTML = '<select data-aos="fade-left">';
        $.each(filesForSlug.dates, function(i, e) {
            yearSelectHTML += `<option value="${e}">${e}</option>`;
        });
        yearSelectHTML += '</select>';
        $(this).append(yearSelectHTML);

        const select = $(this).find('select');

        $(this).append('<div class="files"></div>');

        const filesGroup = $(this).find('.files');
        
        $.each(filesForSlug.arquivos, function(i, e) {
            filesGroup.append(`
                <a href="${e.permalink}" target="_blank" data-select="${e.formattedDate}" style="display:none;" data-aos="fade-left">
                    <span>${e.file_title}</span>
                    <button><svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7443 7.09L16.1543 8.5L8.8614 15.7929C8.47088 16.1834 7.83771 16.1834 7.44719 15.7929L0.154297 8.5L1.5643 7.09L7.1543 12.67L7.1543 0.5H9.1543L9.1543 12.67L14.7443 7.09Z" fill="white"/><path d="M0.154297 20.5H16.1543V18.5H0.154297V20.5Z" fill="white"/></svg></button>
                </a>
            `);
        });
        
        $(select).change(function (e) { 
            e.preventDefault();
            
            const val = $(this).val();

            const files = $(this).parent().find('.files a');

            $.each(files, function (i, e) { 
                if( val == $(this).attr('data-select') ) {
                    $(this).css('display', 'flex');
                } else {
                    $(this).css('display', 'none');
                }
            });

            setTimeout(function () {
                refreshObservers();
            }, 400);
        });

        $(select).trigger('change');
    });
}